import { isBotUserAgent } from '@/utils/utils'
import { onMounted } from 'vue'

export function useUncover() {
    onMounted(async () => {
        if (!isBotUserAgent()) {
            document.body.classList.add('uncover')
        } else {
            document.body.style.transition = 'none'
            document.body.style.opacity = '1'
        }
    })
}
